import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
function Skeleton({ className, ...props }) {
    return _jsx("div", { className: cn("animate-pulse-fade bg-b3-react-background rounded-md", className), ...props });
}
export { Skeleton };
